import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import SafetyRoute from 'components/kea/SafetyRoute';
import asyncComponent from 'util/asyncComponent';
import SignInPage from './SignInPage';
import SignInEmbedded from './SignInEmbedded';
import SubmitNewPassword from './SubmitNewPassword';
import PasswordReset from './PasswordReset';

const SignIn = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <SafetyRoute path={`${match.url}/`} exact render={(props) => <SignInPage {...props} />} />
      <SafetyRoute path={`${match.url}/forgot-password`} exact render={(props) => <SubmitNewPassword {...props} />} />
      <SafetyRoute path={`${match.url}/change-password`} exact render={(props) => <PasswordReset {...props} />} />
      <SafetyRoute path={`${match.url}/:domain/:secret/:app`} exact render={(props) => <SignInEmbedded {...props} />} />

      <Route component={asyncComponent(() => import('app/routes/404'))} />
    </Switch>
  );
};

export default SignIn;
